import React, { ReactNode } from 'react';
import { Button, Col, Modal, Row } from 'antd';

type Props = {
    isVisible: boolean,
    onClose: () => void,
    title: string,
    icon: string,
    text: string | ReactNode,
    showCancelButton: boolean,
    cancelButtonText?: string,
    showConfirmButton: boolean,
    confirmButtonText?: string,
    confirmOnClick?: () => void,
    cancelOnClick?: () => void,
}

const CustomModal = (props: Props) => {
    const {
        icon,
        isVisible,
        onClose,
        text,
        title,
        showCancelButton,
        cancelButtonText,
        showConfirmButton,
        confirmButtonText,
        cancelOnClick,
        confirmOnClick
    } = props;

    return (
        <Modal className='custom-confirmation-modal' visible={isVisible} onCancel={onClose} footer={null}>
            <div className='title'>{title}</div>
            <img src={icon} alt='' className='mx-auto d-block'/>
            <div className='p-4 text-center'>
                {text}
            </div>
            <div className='text-center'>
                <Row justify={'center'} gutter={[10, 10]}>
                    {showCancelButton && (
                        <Col xs={24} md={12}>
                            <Button className='mx-1' block
                                    onClick={cancelOnClick}>{cancelButtonText}</Button>
                        </Col>
                    )}
                    {showConfirmButton && (
                        <Col xs={24} md={12}>
                            <Button className='mx-1' type='primary' block
                                    onClick={confirmOnClick}>{confirmButtonText}</Button>
                        </Col>
                    )}
                </Row>
            </div>
        </Modal>
    );
};

export default CustomModal;
